import React, { memo } from "react";
import { withStyles } from "@material-ui/core";
import styles from "./styles";
import StyledToolTip from "../../../components/common/StyledToolTip";

const SetAPT = ({ classes, eventHub, headerId }) => {
  return (
    <div
      className={`${classes.headerIconStyles} ${classes.iconLayout} ${classes.enabledIcon} glHeaderIcons`}
      onClick={() => eventHub.emit(`${headerId}_setAPTWindow`)}
    >
      <StyledToolTip title="Set APT window based on Delivery DateTime">
        <div>
          <i className={`icon-apt ${classes.aptHeaderIcon}`} />
        </div>
      </StyledToolTip>
    </div>
  );
};

export default withStyles(styles)(memo(SetAPT));